import React, { Component } from 'react';
import Img from 'gatsby-image';
import renderHTML from 'react-render-html';
import { Row, Col } from 'react-flexbox-grid';
import classNames from 'classnames';
import SocialImg from '../components/SocialImg/SocialImg';
import { youtubeParser } from '../utils/parser';
import styles from './projectTemplate.module.less';
import Slider from '../components/Slider/Slider';
import Image from '../components/Image/Image';
import SnapPhone from '../components/SnapPhone/SnapPhone';

export default class Index extends Component {
  constructor(props) {
    super(props);
    this.props.onMount('project', this.props.pathContext.project.backgroundImage.url);
    this.state = {
      sliderActive: false,
      scrollTop: 0,
    };
  }
  // componentWillMount = () => {
  //   // this.props.onMount(this.props.pathContext.project.backgroundImage.url);
  // }
  componentDidMount = () => {
    this.listener.addEventListener('scroll', this.handleScroll());
    if (window.innerWidth > 1024) {
      this.setState({
        isResponsive: false,
      });
    } else {
      this.setState({
        isResponsive: true,
      });
    }
  };
  handleScroll = (e) => {
    this.setState({
      scrollTop: this.listener.scrollTop,
    })
  }
  handleClick = (index) => {
    this.setState({
      sliderActive: true,
      selectedPhoto: index,
    });
  }
  disableSlider = () => {
    this.setState({
      sliderActive: false,
    });
  }

  render() {
    console.log('render');
    let count = 0;
    return (
      // <ParallaxProvider>
      <div onScroll={this.handleScroll} ref={(listener) => { this.listener = listener }} className={styles.contentSurContainer} >
        {/* <div className={styles.contentSurContainer} > */}
        <div className={styles.contentContainer}>
          {/* <div className={classNames(styles.sliderSuperContainer, { [styles.active]: this.state.sliderActive })}>
          <div onClick={this.disableSlider} className={styles.cross} />
          <div className={styles.sliderContainer}>
            <Slider isResponsive={true} active={this.state.selectedPhoto}>
              {this.props.pathContext.project.content.map((element, index) => {
                if (element.image !== undefined) {
                  return (
                    <div className={styles.project} onClick={() => this.handleClick(index)}>
                      <Img className={styles.image} sizes={element.image.sizesBig} />
                    </div>
                  )
                }
              })}
            </Slider>
          </div>
        </div> */}
          <div className={styles.logoContainer}>
            <img className={styles.logo} src={this.props.pathContext.project.client.logoClient.url} />
            {/* <Img className={styles.logo} sizes={this.props.pathContext.project.client.logoClient.sizes} /> */}
          </div>
          {this.props.pathContext.project.client.socialNetworks.length > 0 &&
            <div className={styles.socialSurContainer}>
              <div className={styles.socialContainer}>
                <span className={styles.socialText}>À découvrir sur</span>
                <div className={styles.socialImgsContainer}>
                  {this.props.pathContext.project.client.socialNetworks.map((element) => {
                    return (
                      <SocialImg className={styles.socialLink} socialNetworkName={element.socialNetworkName} socialLink={element.url} />
                    )
                  })}
                </div>
              </div>
            </div>
          }
          <h3 className={styles.title}>{this.props.pathContext.project.title}</h3>
          <div className={styles.description}>
            {renderHTML(this.props.pathContext.project.description)}</div>
          <Row>
            {this.props.pathContext.project.content.map((element, index) => {
              if ('youtubeUrl' in element) {
                return (
                  <Col xs={12}>
                    <div style={{ transform: !this.state.isResponsive ? `translateY(${this.state.scrollTop / 2.5}px)` : 'none' }} className={classNames(styles.videoSurContainer, { [styles.carre]: element.ratio === 'carré', [styles.telephone]: element.ratio === 'téléphone' })}>
                      <div className={styles.videoContainer}>
                        <iframe title="video" width="100%" height="325" src={`https://www.youtube.com/embed/${youtubeParser(element.youtubeUrl.url)}?rel=0&amp;showinfo=0`} frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen className={styles.video} />
                      </div>
                    </div>
                  </Col>
                );
              } else if ('video' in element) {
                return (
                  <Col xs={12} className={styles.flex}>
                    <SnapPhone withPhone={!this.state.isResponsive} url={element.video.url} />
                  </Col>
                );
              } else if ('soundcloudUrl' in element) {
                return (
                  <Col xs={12}>
                    <div className={styles.sonContainer}>
                      {renderHTML(element.soundcloudUrl)}
                    </div>
                  </Col>
                )
              } else if ('image' in element) {
                count++;
                if (count === 1) {
                  return (
                    <Col className={styles.photo} xs={12} sm={6} md={4}>
                      <div style={{ transform: !this.state.isResponsive ? `translateY(${-80 + this.state.scrollTop / 2.5}px)` : 'none' }}>
                        <Image containerClassName={styles.project} className={styles.image} sizesThumbnail={element.image.sizesThumbnail} />
                      </div>
                    </Col>
                  );
                } else if (count === 2) {
                  return (
                    <Col className={styles.photo} xs={12} sm={6} md={4}>
                      <div style={{ transform: !this.state.isResponsive ? `translateY(${-40 + this.state.scrollTop / 3.5}px)` : 'none' }}>
                        <Image containerClassName={styles.project} className={styles.image} sizesThumbnail={element.image.sizesThumbnail} />
                      </div>
                    </Col>
                  );
                } else {
                  count = 0;
                  return (
                    <Col className={styles.photo} xs={12} sm={6} md={4}>
                      <div style={{ transform: !this.state.isResponsive ? `translateY(${this.state.scrollTop / 4.5}px)` : 'none' }}>
                        <Image containerClassName={styles.project} className={styles.image} sizesThumbnail={element.image.sizesThumbnail} />
                      </div>
                    </Col>
                  );
                }
              }
            })}
          </Row>
        </div>
      </div>
      // {/* </ParallaxProvider> */ }
    );
  }
}



// WEBPACK FOOTER //
// ./src/templates/projectTemplate.jsx